<template>
    <div class="in-form-columns-settings-editor">
            <div class="enum-settings-wrapper">
                <table>
                    <tr class="tr-enum">
                        <th class="th-enum"> key </th>
                        <th class="th-enum"> value </th>
                        <th class="th-enum"></th>
                    </tr>
                    <template v-if="Object.keys(enumOptions).length">
                        <tr class="enum-option-row tr-enum" v-for="(value, key) in enumOptions">
                            <td class="td-enum">{{ key }}</td>
                            <td class="td-enum">{{ value }}</td>
                            <td class="td-enum"><ion-icon name="close-outline" @click.stop="removeOption(key)"></ion-icon></td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr class="tr-enum">
                            <td class="td-enum" colspan="3">No options</td>
                        </tr>
                    </template>
                    <tr class="new-enum-option-row tr-enum">
                        <td class="td-enum"><app-input :name="newEnumOption.key" v-model="newEnumOption.key"></app-input></td>
                        <td class="td-enum"><app-input v-model="newEnumOption.value"></app-input></td>
                        <td class="td-enum"><app-button type="primary" @click="addOption">+</app-button></td>
                    </tr>
                </table>
            </div>

        <div class="mt-3">
            <app-button type="primary" @click="save">Save</app-button>
            <app-button type="light" @click="cancel">Cancel</app-button>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        column:{
            type() {
                return Object;
            }
        },
    },
    data() {
        return {
            settings: this.column,
            newEnumOption: {key: '', value: ''},
            }
    },
    methods: {
        addOption() {
            let newEnumKey = this.newEnumOption.key.trim();
            let newEnumValue = this.newEnumOption.value.trim();
            if (this.enumOptions[newEnumKey] !== undefined) {
                this.$notifications.error(('option already exists'));
            } else if (newEnumKey === '' || newEnumValue === '') {
                this.$notifications.error(('specify option name and key'));
            } else if(!/^[\w\d ]+$/.test(newEnumKey) || !/^[\w\d ]+$/.test(newEnumValue)) {
                this.$notifications.error(
                    ('only letters numbers and spaces allowed')
                );
            } else {
                if (this.settings.new_enum_options === undefined) {
                    this.$set(this.settings, 'new enum options', [{key: newEnumKey, value: newEnumValue}]);
                } else {
                    this.settings.new_enum_options.push({key: newEnumKey, value: newEnumValue});
                }

                this.newEnumOption = {key: '', value: ''};
            }
        },
        removeOption(key) {
            this.settings.new_enum_options = this.settings.new_enum_options.filter(item => {
                return item.key != key;
            });
        },
        save() {
            this.$emit('save', this.settings);
        },
        cancel() {
            this.settingsPopUp = {};
            this.$emit('cancel');
        },
    },
    computed: {
        enumOptions() {
            let options = {};

            if (this.settings.new_enum_options) {
                for (let i in this.settings.new_enum_options) {
                    options[this.settings.new_enum_options[i].key] = this.settings.new_enum_options[i].value;
                }
            } else {
                (this.settings.enum_options || []).forEach((option) => {
                    options[option] = option;
                })
            }

            return options;
        }
    }
};
</script>
<style lang="scss" inline>
.in-form-columns-settings-editor {
    padding: 1rem;
}

.enum-option-row {
        text-align: center;
        line-height: 40px;
            cursor: pointer;
    }
.tr-enum{
    line-height: 40px;
    text-align: center;

}
.th-enum, .td-enum {
    border: 1px solid;
}

    .enum-settings-wrapper {
        & > label {
            margin: 0;
        }

        hr {
            margin: .5rem 0;
        }

        table {
            width: 100%;

            th, td {
                border-color: #ccc;
            }
        }
    }


.in-form-form-wrapper {
    position: relative;
    min-height: 10rem;
    background: #fff;
    padding-bottom: 1rem;

}

div.disabled-div {
    pointer-events: none;
    opacity: 0.4;
    cursor: not-allowed;
}


</style>
